// extracted by mini-css-extract-plugin
module.exports = {"container":"BannedUser_container__2Egvr"};